import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../../ui/Tooltip'
import { formatNumber } from '../../ui/KpiCard/status'
import TriggerStates, { TRIGGER_STATE_SHAPE, TRIGGER_WARNING, hasStaleState } from './TriggerStates'

const CARD_CLASS = 'tw:flex tw:flex-col tw:gap-1 tw:rounded! tw:border tw:border-solid tw:border-gray-200 '
  + 'tw:bg-white tw:px-4 tw:py-3'
const LABEL_CLASS = 'tw:flex tw:items-center tw:gap-1 tw:text-sm tw:text-gray-600'
const WARNING_CLASS = 'tw:inline-flex tw:text-orange-700'
const ROW_CLASS = 'tw:flex tw:items-center tw:gap-2'
const GRADE_CLASS = 'tw:text-xl tw:font-bold tw:leading-tight tw:text-gray-950'
const SCALE_CLASS = 'tw:text-base tw:font-medium tw:leading-tight tw:text-gray-400'
const TRACK_CLASS = 'tw:flex-1 tw:h-2.5 tw:rounded-full! tw:bg-orange-100'
const FILL_CLASS = 'tw:block tw:h-full tw:min-w-2.5 tw:rounded-full! tw:bg-orange-700'

const fillPercent = (grade, min, size) => {
  if (size <= min)
    return 0
  return Math.min(100, Math.max(0, (grade - min) / (size - min) * 100))
}

const renderWarning = states => {
  if (!hasStaleState(states))
    return null
  return (
    <Tooltip className={WARNING_CLASS} content={<TriggerStates states={states} />} focusable>
      {TRIGGER_WARNING}
    </Tooltip>
  )
}

const GlobalGradeCard = ({ grade, min, size, states }) => (
  <section aria-label="Note globale" className={CARD_CLASS}>
    <span className={LABEL_CLASS}>
      Note globale
      {renderWarning(states)}
    </span>
    <span className={ROW_CLASS}>
      <span className={GRADE_CLASS}>{formatNumber(grade)}</span>
      <span className={SCALE_CLASS}>{`/ ${size}`}</span>
      <span className={TRACK_CLASS}>
        <span className={FILL_CLASS} style={{ width: `${fillPercent(grade, min, size)}%` }} />
      </span>
    </span>
  </section>
)

GlobalGradeCard.propTypes = {
  grade: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  states: PropTypes.arrayOf(TRIGGER_STATE_SHAPE).isRequired
}

export default GlobalGradeCard
